import { Box, Typography } from '@mui/material'
import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import AbstractArt from '../../assets/images/AbstractImg.png'
import CaseStudyIcon from '../../assets/icons/CaseStudyIcon.png'


const CSChallenges = () => {
  return (
    <Box sx={{
        margin:"2rem 0rem 2rem 0rem",
        position:"relative",
        display:'flex',
        justifyContent:"center",
        height:{xs:'40rem',sm:'inherit'},

    }} >

    <Box  sx={{
        height:{xs:"30rem",sm:'inherit'}
    }} >
          <LazyLoadImage src={AbstractArt} effect="blur" width="100%" height="100%" />
    </Box>

    <Box sx={{
        position:"absolute",
        width:"90%",
        top:"5%",
            }} >

<Typography
          sx={{
            fontFamily: 'Plus Jakarta Sans',
            fontSize: '1.8rem',
            fontWeight:"500",
            marginTop:"1.2rem",
            textAlign:"center",
            marginBottom:"1.2rem",
          }}
        >
          <span style={{ color: 'rgba(255, 102, 0, 1)' }}>Challenges </span> 
          of the project {' '}

        </Typography>
            <Box sx={{
                width:"100%",
                display:"flex",
                flexWrap:"wrap",
                justifyContent:{xs:"center",sm:"space-between"},
                gap:{xs:"0.5rem",sm:"1rem"},
            }} >

<Box sx={{
                width:{xs:"10rem",sm:"20rem"},
                height:{xs:"11rem",sm:"16rem"},
                backgroundColor:"rgba(241, 241, 241, 1)",
                borderRadius:"1.2rem",
                padding:{xs:"0.6rem",sm:"1rem"},
            }} >

<Box sx={{
    width:{xs:"2.5rem",sm:"4.5rem"},
    height:{xs:"2.5rem",sm:"4.5rem"},
    backgroundColor:"rgba(243, 107, 43, 1)",
    borderRadius:"50%",
    display:"flex",
    justifyContent:"center",
    alignItems:"center",
}} >

<Box sx={{
    width:"2.2rem",
}} >
<img src={CaseStudyIcon} alt="" width='100%' />

</Box>

</Box>

<Typography sx={{
                fontFamily: 'Plus Jakarta Sans',
                fontSize:{xs:"0.8rem",sm:"1.2rem"},
                fontWeight:"500",
                marginBottom:"0.8rem",
                marginTop:"0.8rem",
                color:"rgba(51, 51, 51, 1)",


}} >Master of Marketing, GTM & Digital</Typography>
<Typography  sx={{
                fontFamily: 'Plus Jakarta Sans',
                fontSize:{xs:"0.7rem",sm:"1rem"},
                color:"rgba(51, 51, 51, 1)",

}}  >Sed ut perspiciatis unde omnis iste natus error sit voluptatem  Sedantium </Typography>

            </Box>
           
            <Box sx={{
                width:{xs:"10rem",sm:"20rem"},
                height:{xs:"11rem",sm:"16rem"},
                backgroundColor:"rgba(241, 241, 241, 1)",
                borderRadius:"1.2rem",
                padding:{xs:"0.6rem",sm:"1rem"},
            }} >

<Box sx={{
    width:{xs:"2.5rem",sm:"4.5rem"},
    height:{xs:"2.5rem",sm:"4.5rem"},
    backgroundColor:"rgba(243, 107, 43, 1)",
    borderRadius:"50%",
    display:"flex",
    justifyContent:"center",
    alignItems:"center",
}} >

<Box sx={{
    width:"2.2rem",
}} >
<img src={CaseStudyIcon} alt="" width='100%' />

</Box>

</Box>

<Typography sx={{
                fontFamily: 'Plus Jakarta Sans',
                fontSize:{xs:"0.8rem",sm:"1.2rem"},
                fontWeight:"500",
                marginBottom:"0.8rem",
                marginTop:"0.8rem",
                color:"rgba(51, 51, 51, 1)",


}} >Master of Marketing, GTM & Digital</Typography>
<Typography  sx={{
                fontFamily: 'Plus Jakarta Sans',
                fontSize:{xs:"0.7rem",sm:"1rem"},
                color:"rgba(51, 51, 51, 1)",

}}  >Sed ut perspiciatis unde omnis iste natus error sit voluptatem  Sedantium </Typography>

            </Box>

            <Box sx={{
                width:{xs:"10rem",sm:"20rem"},
                height:{xs:"11rem",sm:"16rem"},
                backgroundColor:"rgba(241, 241, 241, 1)",
                borderRadius:"1.2rem",
                padding:{xs:"0.6rem",sm:"1rem"},
            }} >

<Box sx={{
    width:{xs:"2.5rem",sm:"4.5rem"},
    height:{xs:"2.5rem",sm:"4.5rem"},
    backgroundColor:"rgba(243, 107, 43, 1)",
    borderRadius:"50%",
    display:"flex",
    justifyContent:"center",
    alignItems:"center",
}} >

<Box sx={{
    width:"2.2rem",
}} >
<img src={CaseStudyIcon} alt="" width='100%' />

</Box>

</Box>

<Typography sx={{
                fontFamily: 'Plus Jakarta Sans',
                fontSize:{xs:"0.8rem",sm:"1.2rem"},
                fontWeight:"500",
                marginBottom:"0.8rem",
                marginTop:"0.8rem",
                color:"rgba(51, 51, 51, 1)",


}} >Master of Marketing, GTM & Digital</Typography>
<Typography  sx={{
                fontFamily: 'Plus Jakarta Sans',
                fontSize:{xs:"0.7rem",sm:"1rem"},
                color:"rgba(51, 51, 51, 1)",

}}  >Sed ut perspiciatis unde omnis iste natus error sit voluptatem  Sedantium </Typography>

            </Box>

            </Box>

    </Box>
      
    </Box>
  )
}

export default CSChallenges
